import { Form } from "antd";
import React, { useRef } from "react";
import { useFormateMsg } from "../hooks";
import actions from "../store/actions";

import { TitleBar } from "./Model";

const ExFileInput = (props) => {
  const inputRef = useRef();
  const handleChange = (e) => {
    e.persist();
    let file = e.target.files?.[0];
    if (!file) return;
    props.onChange(file);
  };
  const handleClick = () => {
    inputRef.current.click();
  };
  let renderChild;
  if (typeof props.children == "function") {
    renderChild = props.children({ iptClick: handleClick });
  } else {
    renderChild = React.Children.map(props.children, (child) => {
      if (React.isValidElement(child)) {
        //@ts-ignore
        return React.cloneElement(child, { iptClick: handleClick });
      } else {
        return child;
      }
    });
  }
  return (
    <React.Fragment>
      <input
        ref={inputRef}
        style={{ display: "none" }}
        accept="image/*"
        type="file"
        onClick={(e) => (e.currentTarget.value = null)}
        onChange={handleChange}
      />
      {renderChild}
    </React.Fragment>
  );
};

const Upload = (props) => {
  const { onChange, info, value = [] } = props;
  const { formatMsg } = useFormateMsg();
  const handleFileChange = (file) => {
    const fileId = Math.floor(Math.random() * Math.pow(10, 6)) + new Date().getTime();
    let item = { status: "uploading", url: "", fileId };
    value.push(item);
    onChange(value);
    actions
      .upload(file)
      .then((data) => {
        let index = value.findIndex((o) => o.fileId === fileId);
        if (index >= 0) {
          value.splice(index, 1, { ...value[index], status: "success", url: data });
        }
        onChange(value);
      })
      .catch((e) => {
        let index = value.findIndex((o) => o.fileId === fileId);
        if (index >= 0) {
          value.splice(index, 1, { ...value[index], status: "failed" });
        }
        onChange(value);
      });
  };
  const handleRemove = (item) => {
    let index = value.findIndex((o) => o.id == item.fileId);
    value.splice(index, 1);
    onChange(value);
  };
  return (
    <div className="upload-list">
      {value.map((item, i) => {
        return (
          <div className={`list-item ${item.status}`} key={i}>
            {item.status === "uploading" && (
              <>
                <div className="bg"></div>
                <div className="loading"></div>
              </>
            )}
            {item.status === "success" && (
              <React.Fragment>
                <div className="img">
                  <img src={item.url} alt=""></img>
                </div>
              </React.Fragment>
            )}
            {item.status === "failed" && <div className="error">{formatMsg("upload.failed")}</div>}
            {(item.status == "failed" || item.status == "success") && (
              <span className="del-icon" onClick={() => handleRemove(item)}>
                <span className="line"></span>
              </span>
            )}
          </div>
        );
      })}
      {(!info.maxChoice || value.length < info.maxChoice) && (
        <ExFileInput onChange={handleFileChange}>
          {({ iptClick }) => (
            <div className="list-item add-box" onClick={iptClick}>
              <span className="iconfont icon-upload"></span>
              <span className="text">{formatMsg("upload.text")}</span>
            </div>
          )}
        </ExFileInput>
      )}
    </div>
  );
};

const UploadViews = (props) => {
  const { info } = props;
  return (
    <div className="components-upload-views">
      <TitleBar info={info}></TitleBar>
      <Form.Item noStyle name={["postAnswer", info.position]}>
        <Upload info={info}></Upload>
      </Form.Item>
    </div>
  );
};

export default UploadViews;
